import React, { useState, forwardRef, useEffect } from "react";

import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import studentsAPI from "../../../../services/students";
import { Dropdown } from "primereact/dropdown";
import levelsAPI from "../../../../services/levels";

const UpdateRegistrationLevelModal = forwardRef((props, ref) => {
  //
  const schoolId = props?.schoolId;
  const trainingId = props?.trainingId;
  const accessToken = "";
  //
  const [registrationLevel, setRegistrationLevel] = useState(props?.student?.level_id);
  //
  useEffect(() => {
    setRegistrationLevel(props?.student?.level_id);
  }, [props]);
  //
  const levelQuery = levelsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    100000
  );
  //
  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Modifier le niveau"
        serviceAPI={studentsAPI}
        schoolId={schoolId}
        trainingId={trainingId}
        id={props?.student?.id}
        data={{
          level_id: registrationLevel,
        }}
      >
        <Dropdown
          //value={registrationLevel}
          value={levelQuery?.data?.data?.find(
            (obj) => obj.id === registrationLevel
          )}
          options={levelQuery?.data?.data}
          onChange={(e) => setRegistrationLevel(e.value?.id)}
          optionLabel="name"
          placeholder="Sélectionner un niveau"
          checkmark={true}
        />
      </MeaUpdateModal>
    </>
  );
});

export default UpdateRegistrationLevelModal;
